export default __webpack_public_path__ + "5842d9e8c001affdcba3d0f3e436e8c1.png";